import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { createStreamPointer, deleteStreamPointer, getAllStreamPointers } from "./actions";

export const streamPointerEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity[0]._id,
});

const initialState = streamPointerEntityAdapter.getInitialState({
  count: 0,
});

export const streamPointerSlice = createSlice({
  name: "streamPointer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllStreamPointers.fulfilled, (state, action) => {
      if (action.payload.status) {
        const streamPointers = action.payload.data;

        // filter pointers where event is empty
        const filteredStreamPointers = streamPointers
          .map((group) => {
            return group.filter((pointer) => {
              return !(pointer.type === "datafeed-marker" && pointer.event === "");
            });
          })
          .filter((group) => group.length > 0);

        streamPointerEntityAdapter.setAll(state, filteredStreamPointers);
        state.count = filteredStreamPointers.length;
      }
    });

    builder.addCase(createStreamPointer.fulfilled, (state, action) => {
      const newStreamPointer = action.payload.data;
      if (newStreamPointer) {
        streamPointerEntityAdapter.addOne(state, [newStreamPointer]);
        state.count += 1;
      }
    });

    builder.addCase(deleteStreamPointer.fulfilled, (state, action) => {
      const pointerId = action.meta.arg?.pointerId;
      if (pointerId) {
        streamPointerEntityAdapter.removeOne(state, pointerId);
        state.count -= 1;
      }
    });
  },
});

export default streamPointerSlice.reducer;
